var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.826,
    height: 16.939,
    viewBox: "0 0 15.826 16.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 1.296,
    height: 7.818,
    rx: 0.648,
    transform: "translate(4.436 5.933)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 1.296,
    height: 7.818,
    rx: 0.648,
    transform: "translate(10.09 5.933)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 1.296,
    height: 7.818,
    rx: 0.648,
    transform: "translate(7.263 5.933)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M18.239,4.168H14.887L13.222,1.594a.652.652,0,0,0-.544-.294H8.663a.652.652,0,0,0-.544.294L6.458,4.168H3.106a.35.35,0,0,0-.346.35v.6a.346.346,0,0,0,.346.346H4.283V15.893A2.35,2.35,0,0,0,6.63,18.239h8.082a2.35,2.35,0,0,0,2.346-2.346V5.453h1.181a.346.346,0,0,0,.346-.346h0v-.6A.35.35,0,0,0,18.239,4.168ZM9.013,2.6h3.311l1.013,1.572H8Zm6.749,13.267a1.051,1.051,0,0,1-1.05,1.05H6.63a1.051,1.051,0,0,1-1.05-1.05V5.453H15.762Z",
    transform: "translate(-2.76 -1.3)",
    fill: "#bdbdbd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.920d4dd9ba9fd95b21ad3699cfcc4f73.svg";
export { ForwardRef as ReactComponent };